
<script >
import { isPc } from '../fego/utils';
import { ref, computed, watch } from 'vue-demi';
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
import PopupTranstion from './PopupTranstion/index.vue';
const __sfc_main = {
  components: {
    FlowContainer: ComplexComp.Container.Flow,
    PopupTranstion
  }
};
__sfc_main.props = {
  tpl: Object,
  defaultVisible: Number,
  zIndex: Number,
  clickMaskClose: {
    type: Boolean,
    default: true
  },
  lockScroll: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    nextZIndex,
    useTeleport,
    useLockScreen
  } = require('@futuweb/fego-render').plugins.PopupManager;
  const props = __props;
  // 传送到body
  useTeleport(document.body);

  // 显示隐藏逻辑
  const visible = ref(!!props.defaultVisible);
  if (props.lockScroll) {
    useLockScreen(visible);
  }
  const open = () => {
    visible.value = true;
  };
  const close = () => {
    visible.value = false;
  };

  // 处理层级
  const zIndex = ref(0);
  if (props.zIndex !== 0 && !props.zIndex) {
    zIndex.value = nextZIndex();
    watch(visible, () => {
      if (visible.value) {
        zIndex.value = nextZIndex();
      }
    });
  } else {
    zIndex.value = props.zIndex;
  }
  const zIndexStyle = computed(() => ({
    zIndex: zIndex.value
  }));

  // 对外暴露的方法
  return Object.assign({
    isPc,
    visible,
    close,
    zIndexStyle
  }, {
    open,
    close
  });
};
__sfc_main.components = Object.assign({
  PopupTranstion
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <PopupTranstion>
        <div
            v-if="visible"
            :class="[
                'basic-up-modal',
                {
                    pc: isPc()
                }
            ]"
            :style="zIndexStyle"
        >
            <div class="mask" @click="() => clickMaskClose && close()"></div>
            <div ref="content" class="popup-panel">
                <img
                    class="close-icon"
                    src="https://static.futunn.com/upload/01fego/close-icon-7abd5649416bbd149db0d9c9d8fe28db.png?_=1688980995952"
                    @click="close"
                    alt=""
                />
                <section class="popup-content">
                    <flow-container :children="tpl.children"></flow-container>
                </section>
            </div>
        </div>
    </PopupTranstion>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
